<div class="hero-section">
  <div class="hero-content">
    <h1>Construction & Home Repair Services</h1>
    <p>Licensed pros for new builds, renovations, and emergency fixes — find trusted help fast.</p>
  </div>

  <div class="search-wrapper">
    <div class="search-container">
      <!-- Search row -->
      <div class="search-row">
        <input
          type="text"
          [formControl]="searchControl"
          placeholder="Search (e.g., roof leak, new wiring)"
          aria-label="Search services"
          class="search-input"
        />
        <select [formControl]="categoryControl" (change)="applyFilters()" aria-label="Category" class="search-select">
          <option value="">All Categories</option>
          <option *ngFor="let cat of categories" [value]="cat.value">{{ cat.label }}</option>
        </select>
        <button type="button" (click)="applyFilters()" class="search-btn">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <!-- Quick filters -->
      <div class="quick-filters">
        <p class="qf-label">Popular:</p>
        <div class="qf-chips">
          <button type="button" *ngFor="let cat of categories | slice:0:6"
            (click)="categoryControl.setValue(cat.value); applyFilters()"
            class="qf-chip" [class.active]="categoryControl.value === cat.value">{{ cat.label }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Provider-as-customer error -->
<div *ngIf="bookingError" class="booking-alert-bar">
  <mat-icon>info</mat-icon>
  <span>{{ bookingError }}</span>
  <button type="button" (click)="bookingError = null">×</button>
</div>

<div class="page-body">
  <div class="page-inner">

    <!-- Filters bar -->
    <div class="filters-bar">
      <div class="filters-count">
        <span class="count-num">{{ filteredServices.length }}</span>
        <span class="count-of">of {{ services.length }} services</span>
      </div>
      <div class="filters-controls">
        <!-- Price Filter -->
        <div class="filter-control">
          <mat-icon class="filter-icon">attach_money</mat-icon>
          <select [(ngModel)]="priceFilter" (change)="applyFilters()" class="filter-select">
            <option value="all">All Prices</option>
            <option value="under200">&lt;$200</option>
            <option value="200to1000">$200–$1k</option>
            <option value="over1000">&gt;$1k</option>
          </select>
        </div>
        <!-- Rating Filter -->
        <div class="filter-control">
          <mat-icon class="filter-icon">star</mat-icon>
          <label class="filter-checkbox-label" [class.checked]="minRating >= 4">
            <input type="checkbox"
              (change)="minRating = minRating === 4 ? 0 : 4; applyFilters()"
              [checked]="minRating >= 4">
            4+ Stars
          </label>
        </div>
        <!-- Sort -->
        <div class="filter-control">
          <mat-icon class="filter-icon">sort</mat-icon>
          <select [(ngModel)]="sortBy" (change)="sortServices()" class="filter-select">
            <option value="relevance">Relevance</option>
            <option value="price-low">Low → High</option>
            <option value="price-high">High → Low</option>
            <option value="rating">Top Rated</option>
          </select>
        </div>
        <button type="button" (click)="resetFilters()" class="reset-btn">
          <mat-icon>restart_alt</mat-icon> Reset
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="state-center">
      <div class="css-loading-spinner"></div>
      <p>Loading services…</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && filteredServices.length === 0" class="empty-state">
      <mat-icon>search_off</mat-icon>
      <h3>No Services Found</h3>
      <p>Try adjusting your filters or searching a different term.</p>
      <button mat-raised-button color="primary" (click)="resetFilters()">
        <mat-icon>restart_alt</mat-icon> Reset Filters
      </button>
    </div>

    <!-- Services Grid -->
    <div class="services-grid" *ngIf="!loading && filteredServices.length > 0">
      <article class="svc-card" *ngFor="let s of filteredServices">

        <!-- Image -->
        <div class="svc-img-wrap">
          <img [src]="s.imageUrl" [alt]="s.title" class="svc-img"
               onerror="this.onerror=null; this.src='data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27300%27 height=%27200%27%3E%3Crect width=%27100%25%27 height=%27100%25%27 fill=%27%23e2e8f0%27/%3E%3Ctext x=%2750%25%27 y=%2750%25%27 font-family=%27sans-serif%27 font-size=%2718%27 fill=%27%23718096%27 text-anchor=%27middle%27 dominant-baseline=%27middle%27%3EService%3C/text%3E%3C/svg%3E'">
        </div>

        <!-- Content -->
        <div class="svc-body">
          <div class="svc-top">
            <h3 class="svc-title">{{ s.title }}</h3>
            <div class="svc-price-row">
              <span class="svc-price">${{ s.price | number }}</span>
              <span class="svc-price-label">est.</span>
              <span class="svc-category">{{ s.category | titlecase }}</span>
            </div>
            <div class="svc-rating">
              <mat-icon class="star-icon">star</mat-icon>
              <span class="rating-val">{{ s.rating | number:'1.1-1' }}</span>
            </div>
            <p class="svc-desc">{{ s.description.length > 80 ? (s.description | slice:0:80) + '…' : s.description }}</p>
          </div>

          <div class="svc-footer">
            <div class="svc-provider">
              <div class="provider-avatar">{{ s.provider?.charAt(0) | uppercase }}</div>
              <span class="provider-name">{{ s.provider }}</span>
            </div>
            <button mat-raised-button color="primary" class="book-btn"
                    (click)="bookService(s, $event)">
              <mat-icon>event_available</mat-icon> Book
            </button>
          </div>
        </div>

      </article>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalPages > 1" class="pagination">
      <button mat-stroked-button *ngFor="let p of [].constructor(totalPages); let i = index"
              [color]="page === i + 1 ? 'primary' : ''"
              (click)="changePage(i + 1)">
        {{ i + 1 }}
      </button>
    </div>

  </div>
</div>

<!-- ── Booking Modal ── -->
<div class="booking-overlay" *ngIf="showBookingModal" (click)="closeModal()">
  <div class="booking-modal" (click)="$event.stopPropagation()">

    <div *ngIf="bookingSuccess" class="booking-success">
      <div class="success-icon"><mat-icon>check_circle</mat-icon></div>
      <h2>Booking Requested!</h2>
      <p>Your request for <strong>{{ selectedService?.title }}</strong> has been sent to <strong>{{ selectedService?.provider }}</strong>. You'll receive confirmation shortly.</p>
      <button mat-raised-button color="primary" (click)="closeModal()">Done</button>
    </div>

    <ng-container *ngIf="!bookingSuccess">
      <div class="booking-modal-header">
        <div>
          <h2 class="booking-modal-title">Request a Booking</h2>
          <p class="booking-modal-sub">{{ selectedService?.title }}</p>
        </div>
        <button mat-icon-button (click)="closeModal()"><mat-icon>close</mat-icon></button>
      </div>

      <!-- Step progress -->
      <div class="booking-steps">
        <div class="step-track">
          <div class="step-track-fill" [style.width.%]="(bookingStep - 1) / (totalBookingSteps - 1) * 100"></div>
        </div>
        <div class="step-labels">
          <span [class.active]="bookingStep >= 1">1. When</span>
          <span [class.active]="bookingStep >= 2">2. Where</span>
          <span [class.active]="bookingStep >= 3">3. Confirm</span>
        </div>
      </div>

      <form [formGroup]="bookingForm" (ngSubmit)="submitBooking()" class="booking-form">

        <!-- Step 1: When -->
        <div class="booking-step-panel" *ngIf="bookingStep === 1">
          <p class="step-question">When do you need this done?</p>
          <div class="chip-row">
            <button type="button" *ngFor="let u of urgencyOptions" class="urgency-chip"
                    [class.selected]="selectedUrgency === u.value"
                    (click)="selectUrgency(u.value)">{{ u.label }}</button>
          </div>

          <div class="booking-two-col">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Preferred Date</mat-label>
              <input matInput type="date" formControlName="date" [min]="minDate" />
              <mat-error>Date is required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Preferred Time</mat-label>
              <input matInput type="time" formControlName="time" />
              <mat-error>Time is required</mat-error>
            </mat-form-field>
          </div>

          <p class="step-question">One-time or recurring?</p>
          <div class="chip-row">
            <button type="button" class="urgency-chip" [class.selected]="!bookingForm.value.isRecurring"
                    (click)="bookingForm.patchValue({ isRecurring: false, recurringFrequency: '' })">One-time</button>
            <button type="button" class="urgency-chip" [class.selected]="bookingForm.value.isRecurring"
                    (click)="bookingForm.patchValue({ isRecurring: true })">Recurring</button>
          </div>
          <mat-form-field appearance="outline" class="full-width" *ngIf="bookingForm.value.isRecurring">
            <mat-label>How often?</mat-label>
            <mat-select formControlName="recurringFrequency">
              <mat-option *ngFor="let r of recurringOptions" [value]="r.value">{{ r.label }}</mat-option>
            </mat-select>
            <mat-error>Frequency is required</mat-error>
          </mat-form-field>
        </div>

        <!-- Step 2: Where -->
        <div class="booking-step-panel" *ngIf="bookingStep === 2">
          <p class="step-question">Where should the pro go?</p>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Service Address</mat-label>
            <textarea matInput formControlName="address" rows="2"
                      placeholder="Where should the provider come?"></textarea>
            <mat-error>Address is required</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Notes (optional)</mat-label>
            <textarea matInput formControlName="notes" rows="3"
                      placeholder="Tell the pro more about your project"></textarea>
          </mat-form-field>
        </div>

        <!-- Step 3: Confirm -->
        <div class="booking-step-panel" *ngIf="bookingStep === 3">
          <p class="step-question">Review your request</p>
          <div class="review-card">
            <div class="review-row"><span>Service</span><strong>{{ selectedService?.title }}</strong></div>
            <div class="review-row"><span>Provider</span><strong>{{ selectedService?.provider }}</strong></div>
            <div class="review-row"><span>Estimated Price</span><strong class="price-highlight">{{ selectedService?.price | currency }}</strong></div>
            <div class="review-row"><span>Date</span><strong>{{ bookingForm.value.date }}</strong></div>
            <div class="review-row"><span>Time</span><strong>{{ bookingForm.value.time }}</strong></div>
            <div class="review-row" *ngIf="bookingForm.value.isRecurring">
              <span>Frequency</span><strong>{{ bookingForm.value.recurringFrequency }}</strong>
            </div>
            <div class="review-row"><span>Address</span><strong>{{ bookingForm.value.address }}</strong></div>
            <div class="review-row" *ngIf="bookingForm.value.notes">
              <span>Notes</span><strong>{{ bookingForm.value.notes }}</strong>
            </div>
          </div>
        </div>

        <div class="booking-form-actions">
          <button type="button" mat-stroked-button [disabled]="isSubmitting"
                  (click)="bookingStep === 1 ? closeModal() : prevStep()">
            {{ bookingStep === 1 ? 'Cancel' : 'Back' }}
          </button>
          <button type="button" mat-raised-button color="primary" *ngIf="bookingStep < totalBookingSteps"
                  (click)="nextStep()">
            Next
          </button>
          <button type="submit" mat-raised-button color="primary" *ngIf="bookingStep === totalBookingSteps"
                  [disabled]="isSubmitting">
            <mat-icon>event_available</mat-icon>
            {{ isSubmitting ? 'Submitting…' : 'Confirm Booking' }}
          </button>
        </div>
      </form>
    </ng-container>
  </div>
</div>
